// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FormasPagamentoFranquia_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/formas_pagamento_franquias/lista
 *
 * Wire shape: dados is a flat list of FormasPagamentoFranquia_ItemRow, uma por forma do catálogo.
 */
import type { FormasPagamentoFranquia_ItemRow } from './FormasPagamentoFranquia_ItemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type FormasPagamentoFranquia_ListaResponseDados = FormasPagamentoFranquia_ItemRow[];

export type FormasPagamentoFranquia_ListaResponse = ApiResponse<FormasPagamentoFranquia_ListaResponseDados>;

registerResponseContract('FormasPagamentoFranquia_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      forma_pagamento_id:                  { type: 'number',  required: true },
      forma_pagamento_nome:                { type: 'string',  required: true },
      background_color:                    { type: 'string',  required: false },
      forma_pagamento_codigo:              { type: 'string',  required: false },
      forma_pagamento_possui_taxas:        { type: 'number',  required: false },
      forma_pagamento_aceita_parcelado:    { type: 'number',  required: false },
      forma_pagamento_taxa_mensal:         { type: 'number',  required: false },
      forma_pagamento_taxa_transacao:      { type: 'number',  required: false },
      forma_pagamento_taxa_transacao_tipo: { type: 'number',  required: false },
      forma_pagamento_parcelas_max:        { type: 'number',  required: false },
      forma_pagamento_dias_para_receber:   { type: 'number',  required: false },
      fpf_possui_taxas:                    { type: 'number',  required: false },
      fpf_aceita_parcelado:                { type: 'number',  required: false },
      fpf_taxa_mensal:                     { type: 'number',  required: false },
      fpf_taxa_transacao:                  { type: 'number',  required: false },
      fpf_taxa_transacao_tipo:             { type: 'number',  required: false },
      fpf_parcelas_max:                    { type: 'number',  required: false },
      fpf_dias_para_receber:               { type: 'number',  required: false },
    },
  },
})
